module.exports = __webpack_public_path__ + "static/media/2 (35).a6bf7a4d.jpg";